{
  "language": "en",
  "englishName": "English (United States)",
  "nativeName": "English (United States)",
  "direction": "left-to-right",
  "calendars": [{
    "name": "gregorian",
    "dateFormat": {
      "separator": "/",
      "timeSeparator": ":",
      "short": "M/d/yyyy",
      "medium": "MMM d, yyyy",
      "long": "MMMM d, yyyy",
      "full": "EEEE, MMMM d, y",
      "month": "MMMM d",
      "year": "MMMM yyyy",
      "dayOfWeek": "d EEE",
      "timestamp": "h:mm:ss a",
      "timestampMillis": "h:mm:ss:SSS a",
      "hour": "h:mm a",
      "datetime": "M/d/yyyy h:mm a",
      "datetimeMillis": "M/d/yyyy h:mm:ss:SSS a",
      "timezone": "M/d/yyyy h:mm a zz",
      "timezoneLong": "M/d/yyyy h:mm a zzzz"
    },
    "days": {
      "wide": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "abbreviated": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      "narrow": ["S", "M", "T", "W", "T", "F", "S"]
    },
    "months": {
      "wide": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      "abbreviated": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    },
    "timeFormat": "h:mm a",
    "dayPeriods": ["AM", "PM"],
    "firstDayofWeek": 0
  }],
  "currencySign": "$",
  "currencyFormat": "¤###",
  "numbers": {
    "percentSign": "%",
    "percentFormat": "### %",
    "percentSuffix": " %",
    "percentPrefix": "",
    "minusSign": "-",
    "decimal": ".",
    "group": ",",
    "groupSizes": [3, 3]
  }
}
